import { render, staticRenderFns } from "./consultCreate.vue?vue&type=template&id=72e0ec00&scoped=true"
import script from "./consultCreate.vue?vue&type=script&lang=js"
export * from "./consultCreate.vue?vue&type=script&lang=js"
import style0 from "./consultCreate.vue?vue&type=style&index=0&id=72e0ec00&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e0ec00",
  null
  
)

export default component.exports